import HtmlComponent from './HtmlComponent';
import Props from './Props';

const P = (props: Props) => <HtmlComponent tag="p" {...props} />;

export default P;
